import { IReward } from "api/types";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { sortRewards } from "screens/RedeemRewards/utils";
import Reward from "./Reward";
interface IRewardList {
  rewards: IReward[];
  pointsBalance?: number;
  tenantId?: string;
  locationId?: string;
  imageBaseUrl?: string;
  addToCart?(reward: IReward): void;
}

const RewardsList = ({
  rewards = [],
  addToCart,
  pointsBalance,
  tenantId,
  locationId,
  imageBaseUrl
}: IRewardList) => {
  return (
    <Row style={{ overflowY: "auto" }}>
      {sortRewards(rewards).map((reward: IReward, i: number) => (
        <Col xs={6} lg={4} key={i}>
          <Reward
            reward={reward}
            addToCart={addToCart}
            pointsBalance={pointsBalance}
            tenantId={tenantId}
            locationId={locationId}
            imageBaseUrl={imageBaseUrl}
          />
        </Col>
      ))}
    </Row>
  );
};

export default RewardsList;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/RewardsList/RewardsList.tsx